var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverlayProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.65625C6.04297 0.65625 0.40625 6.29297 0.40625 13.25C0.40625 20.207 6.04297 25.8438 13 25.8438C19.957 25.8438 25.5938 20.207 25.5938 13.25C25.5938 6.29297 19.957 0.65625 13 0.65625ZM13 5.53125C15.4375 5.53125 17.4688 7.5625 17.4688 10C17.4688 12.4883 15.4375 14.4688 13 14.4688C10.5117 14.4688 8.53125 12.4883 8.53125 10C8.53125 7.5625 10.5117 5.53125 13 5.53125ZM13 23C10.0039 23 7.3125 21.6797 5.53516 19.5469C6.5 17.7695 8.37891 16.5 10.5625 16.5C10.6641 16.5 10.7656 16.5508 10.918 16.6016C11.5781 16.8047 12.2383 16.9062 13 16.9062C13.7109 16.9062 14.4219 16.8047 15.0312 16.6016C15.1836 16.5508 15.2852 16.5 15.4375 16.5C17.5703 16.5 19.4492 17.7695 20.4141 19.5469C18.6367 21.6797 15.9453 23 13 23Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayProfile);
export default __webpack_public_path__ + "static/media/OverlayProfile.06dd6fab.svg";
export { ForwardRef as ReactComponent };